// Administración · Equipo y accesos — el alcance por tiendas de cada
// integrante (autogestión 2026-10-30 §2.3, T-jre9).
//
// El alcance no vive en auth-svc: se deriva de tres columnas de core-api
// (assets.store_manager_user_id, assets.supervisor_user_id y
// asset_groups.supervisor_user_id, lib/scoped-assets.ts). El roster
// (GET /auth/memberships) trae a la gente; esta lectura trae qué tiene
// cada una a cargo, por id, y el dashboard junta ambas para la columna
// «Acceso» («Zona Norte · 5 tiendas», «AS-014»). Sin PII: sólo ids.
import { z } from "zod";
// GET /organizations/me/member-scopes
export const memberScopeItemSchema = z.object({
    userId: z.string().uuid(),
    /** Tiendas asignadas directo (la columna que corresponde al rol). */
    assetIds: z.array(z.string().uuid()),
    /** Zonas que supervisa (asset_groups.supervisor_user_id). */
    assetGroupIds: z.array(z.string().uuid()),
});
export const memberScopesResponseSchema = z.object({
    /** Sólo quien tiene algo a cargo; un usuario aparece una vez. */
    items: z.array(memberScopeItemSchema),
});
// PUT /organizations/me/members/:userId/scope — el diff sobre TIENDAS
// (assets). El rol del integrante no viaja en el cuerpo: core-api lo lee
// del roster de auth-svc con el JWT del caller y elige la columna por
// STAMP_BY_ROLE (lib/invitation-asset-stamp.ts). Las zonas se cambian
// por PUT /asset-groups/:id {supervisorUserId}, no por acá.
const MAX_SCOPE_IDS = 500;
export const memberScopeUpdateBodySchema = z
    .object({
    add: z.array(z.string().uuid()).max(MAX_SCOPE_IDS).default([]),
    remove: z.array(z.string().uuid()).max(MAX_SCOPE_IDS).default([]),
    /** Con `true`, una tienda que ya tiene a OTRO titular pasa a este
     *  integrante; sin él la ruta responde 409 ASSET_HOLDER_OCCUPIED con
     *  {assetId, unit} en `details`. Espejo de `replaceSupervisor` en
     *  PUT /asset-groups/:id. */
    replace: z.boolean().optional(),
})
    .strict()
    .refine((b) => b.add.length > 0 || b.remove.length > 0, {
    message: "add or remove must name at least one store",
})
    .refine((b) => !b.add.some((id) => b.remove.includes(id)), {
    message: "a store cannot be in both add and remove",
});
export const memberScopeUpdateResponseSchema = z.object({
    userId: z.string().uuid(),
    /** Estado final: las tiendas cuya columna del rol apunta al integrante. */
    assetIds: z.array(z.string().uuid()),
});
/** `details` del 409 ASSET_HOLDER_OCCUPIED: la tienda que ya tiene titular. */
export const assetHolderOccupiedDetailsSchema = z.object({
    assetId: z.string().uuid(),
    unit: z.string().nullable(),
});
//# sourceMappingURL=member-scopes.js.map